import React, { useState, useEffect, useRef } from 'react';
import { TableCell, LinearProgress, TableRow, TableContainer, Table, TableHead, TableBody, Button, makeStyles, Modal, Paper, Typography, } from "@material-ui/core";
import { useParams } from 'react-router-dom';
import { cancelBooking } from '../firebase/cancelBooking'
import { firestore } from "../firebase/firebase";


const UserTable = ({ store, events }) => {
  let { storeId, eventId, slotId } = useParams();
  const isMounted = useRef(false);
  const paramsEventRef = `stores/${storeId}/events/${eventId}/slots/${slotId}`;
  const [userId, setUserId] = useState("")
  const [userName, setUserName] = useState("")
  const [memberId, setMemberId] = useState("");
  const [unbookModalOpen, setUnbookModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const unsubsribeFromSlotUsers = useRef(null);
  const [usersBookings, setUsersBookings] = useState([]);

  useEffect(() => {
    isMounted.current = true;
    return (
      () => {
        isMounted.current = false;
        unsubscribe();
      }
    );
  }, []);

  useEffect(() => {
    setIsLoading(true)
    const usersSnapshot = firestore
      .collection("stores")
      .doc(storeId)
      .collection("events")
      .doc(eventId)
      .collection("slots")
      .doc(slotId)
      .collection("users");
    unsubscribe();
    unsubsribeFromSlotUsers.current = usersSnapshot.onSnapshot((snapshot) => {
      if (isMounted.current) {
        setUsersBookings(snapshot.docs.map(doc => {
          const data = doc.data();
          return {
            userId: doc.id,
            name: data.firstName ? data.firstName : "" + " " + data.lastName ? data.lastName : "",
            memberId: data.memberId,
          };
        }));
        setIsLoading(false);
      }
    });
  }, [slotId]);

  const unsubscribe = () => {
    unsubsribeFromSlotUsers.current && unsubsribeFromSlotUsers.current();
  };

  const handleUnbookModalClose = () => {
    setUnbookModalOpen(false);
  };

  const handleUnbookModal = () => {
    setUnbookModalOpen(true);
  };

  const setCurrentUser = (memberId, userName, userId) => {
    setMemberId(memberId);
    setUserName(userName);
    setUserId(userId);
  };

  const handleCancelBooking = async (userId, paramsEventRef) => {
    setIsLoading(true);
    handleUnbookModalClose();
    await cancelBooking(userId, paramsEventRef);
    if (isMounted.current) {
      setIsLoading(false);
    };
  };

  const classes = useStyles();
  return (
    <>
      {isLoading ? <div className={classes.laddar}>
        Laddar medlemmar <br></br> <LinearProgress color="primary" />
      </div>
        :
        <Paper >
          <div
            style={{ width: "100%", padding: "0" }}
          >
            <TableContainer padding='none'>
              <Table size='small' aria-label="Boka tid">
                <TableHead>
                  <TableRow style={{ borderBottom: "1px solid #e0e0e0" }}>
                    <TableCell compoent='th' scope='row'>Namn</TableCell>
                    <TableCell align='left' compoent='th' scope='row'>Medlemsnummer</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className={classes.tableRow}>
                  {
                    usersBookings?.map((user) => {
                      return (
                        <TableRow
                          key={user.memberId}
                          className={classes.tableRow}
                        >
                          <TableCell style={{ padding: "0.8rem 0 0.8rem 1rem" }}>{user.name}</TableCell>
                          <TableCell>{user.memberId}</TableCell>
                          <TableCell
                            style={{ cursor: "pointer", textAlign: "center" }}
                            onClick={() => {
                              handleUnbookModal();
                              setCurrentUser(user.memberId, user.name, user.userId)
                            }}
                          >
                            <Button variant='text'
                              color='primary'
                            >AVBOKA</Button>
                          </TableCell>
                        </TableRow>
                      )
                    })
                  }
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </Paper>
      }
      <Modal
        open={unbookModalOpen}
        onClose={handleUnbookModalClose}
        aria-labelledby="Boka tid"
        aria-describedby="Boka tid genom att ange medlemsnummer"
      >
        <div className={classes.modal}>
          <Paper className={classes.paper}>
            <Typography
              component='h6'
              variant='h6'
              color='primary'
              style={{ textAlign: 'left', marginBottom: 0 }}
            >{store?.name}
              {
                Object.keys(events).map((key) => {
                  const event = events[key];
                  if (event.id === eventId) {
                    return (
                      <div key={event.id}>
                        <Typography style={{ color: "black" }}>
                          {`${event.dateString}, kl ${slotId}`}
                        </Typography>
                        <br></br>
                        <Typography style={{ color: "black" }}>
                          Vill du avboka tid for <span className={classes.spanText}>{userName}</span>,
                          medlemsnummer <span className={classes.spanText}>{memberId}</span>?
                        </Typography>
                      </div>
                    )
                  }
                })}
            </Typography>
            {
              <>
                <form className={classes.root} noValidate autoComplete='off'>
                  <div style={{ marginTop: 50, textAlign: 'right' }}>
                    <Button
                      variant='text'
                      color='primary'
                      onClick={handleUnbookModalClose}
                    >
                      Avbryt
                    </Button>
                    <Button
                      variant='contained'
                      color='primary'
                      style={{ marginLeft: 20 }}
                      onClick={() => { handleCancelBooking(userId, paramsEventRef) }}
                    >
                      Bekräfta
                    </Button>
                  </div>
                </form>
              </>
            }
          </Paper>
        </div>
      </Modal>
    </>
  )
}

export default UserTable

const useStyles = makeStyles((theme) => ({
  tableRow: {
    "& :hover": {
      backgroundColor: '#ebebeb',
    }
  },
  unbook: {
    textAlign: 'center',
    cursor: "pointer",
    fontSize: "0.9rem",
    color: '#006564',
    // textDecoration: "underline",
    "& :hover": {
      backgroundColor: '#006564'
    },
  },
  modal: {
    width: 600,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  laddar: {
    textAlign: "center",
    padding: 30,
    marginBottom: "100%",
    backgroundColor: "rgb(221,221,221)",
    borderRadius: 4,
    width: "30%",
    margin: "auto"
  },
  spanText: {
    color: "rgb(0 101 100)",
    fontWeight: 800
  },
}));